import { render } from "./toggle-switch.vue?vue&type=template&id=b21c2208&ts=true"
import script from "./toggle-switch.vue?vue&type=script&lang=ts"
export * from "./toggle-switch.vue?vue&type=script&lang=ts"

import "./toggle-switch.vue?vue&type=style&index=0&id=b21c2208&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__